export const V2WithdrawalTokens: Record<
  string,
  {
    id: number
    symbol: string
    chains: Record<
      string,
      {
        address: string
        chainId: number
        decimals: number
        fastWithdraw: boolean
      }
    >
  }
> = {
  '140': {
    id: 140,
    chains: {
      '1': {
        address: '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
        chainId: 1,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'DAI',
  },
  '141': {
    id: 141,
    chains: {
      '1': {
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        chainId: 1,
        decimals: 6,
        fastWithdraw: false,
      },
      '10': {
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        chainId: 10,
        decimals: 6,
        fastWithdraw: false,
      },
      '2': {
        address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        chainId: 2,
        decimals: 6,
        fastWithdraw: false,
      },
      '7': {
        address: '0xa219439258ca9da29e9cc4ce5596924745e12b93',
        chainId: 7,
        decimals: 6,
        fastWithdraw: false,
      },
      '9': {
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        chainId: 9,
        decimals: 6,
        fastWithdraw: false,
      },
    },
    symbol: 'USDT',
  },
  '142': {
    id: 142,
    chains: {
      '9': {
        address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        chainId: 9,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'ARB',
  },
  '143': {
    id: 143,
    chains: {
      '10': {
        address: '0x4200000000000000000000000000000000000042',
        chainId: 10,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'OP',
  },
  '18': {
    id: 18,
    chains: {
      '1': {
        address: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
        chainId: 1,
        decimals: 6,
        fastWithdraw: false,
      },
      '10': {
        address: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        chainId: 10,
        decimals: 6,
        fastWithdraw: false,
      },
      '2': {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        chainId: 2,
        decimals: 6,
        fastWithdraw: false,
      },
      '5': {
        address: '0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4',
        chainId: 5,
        decimals: 6,
        fastWithdraw: false,
      },
      '7': {
        address: '0x176211869ca2b568f2a7d4ee941e073a821ee1ff',
        chainId: 7,
        decimals: 6,
        fastWithdraw: false,
      },
      '9': {
        address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        chainId: 9,
        decimals: 6,
        fastWithdraw: false,
      },
    },
    symbol: 'USDC',
  },
  '33': {
    id: 33,
    chains: {
      '1': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 1,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'MATIC',
  },
  '34': {
    id: 34,
    chains: {
      '2': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 2,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'AVAX',
  },
  '35': {
    id: 35,
    chains: {
      '15': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 15,
        decimals: 18,
        fastWithdraw: false,
      },
      '3': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 3,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'BNB',
  },
  '36': {
    id: 36,
    chains: {
      '10': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 10,
        decimals: 18,
        fastWithdraw: false,
      },
      '11': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 11,
        decimals: 18,
        fastWithdraw: false,
      },
      '5': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 5,
        decimals: 18,
        fastWithdraw: false,
      },
      '7': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 7,
        decimals: 18,
        fastWithdraw: false,
      },
      '9': {
        address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        chainId: 9,
        decimals: 18,
        fastWithdraw: false,
      },
    },
    symbol: 'ETH',
  },
} as const
